﻿class Expander {
    constructor(toggleButton) {
        this.timerStart = null;
        this.timerDone = null;
        this.toggleButton = toggleButton;
        this.targetId = this.toggleButton.getAttribute('data-expand-id');
        this.targetElement = document.getElementById(this.targetId);
        this.targetElement.style.height = '0px';
        this.toggleButton.onclick = this.buttonClick.bind(this);

        //todo: links direkte til dette id skal starte expanded


        if (window.location.hash.substr(1) == this.targetId) {
            this.toggleButton.classList.add('expander--on');
            this.targetElement.classList.add('expander--expanded');
            this.targetElement.style.height = 'auto';
            this.toggleButton.scrollIntoView();
        }
    }

    buttonClick() {
        if (this.targetElement.classList.contains('expander--expanded')) {
            this.collapse();
        } else {
            this.expand();
        }
    }

    expand() {
        this.toggleButton.classList.add('expander--on');
        this.targetElement.classList.add('expander--expanded');

        //reset
        clearTimeout(this.timerStart);
        clearTimeout(this.timerDone);

        //start transition
        this.targetElement.classList.add('expander--transition');
        this.targetElement.style.height = this.targetElement.scrollHeight + 'px';

        //endt transition
        this.timerDone = setTimeout(function () {
            this.targetElement.style.height = 'auto';
            this.targetElement.classList.remove('expander--transition');
        }.bind(this), 1000);
    }

    collapse() {
        this.toggleButton.classList.remove('expander--on');
        this.targetElement.classList.remove('expander--expanded');

        //reset
        clearTimeout(this.timerStart);
        clearTimeout(this.timerDone);
        this.targetElement.classList.remove('expander--transition');
        this.targetElement.style.height = this.targetElement.scrollHeight + 'px';

        //start transition
        this.timerStart = setTimeout(function () {
            this.targetElement.classList.add('expander--transition');
            this.targetElement.style.height = '0px';
        }.bind(this), 100);

        //end transition
        this.timerDone = setTimeout(function () {
            this.targetElement.classList.remove('expander--transition');
        }.bind(this), 1000);
    }
}


window.addEventListener('DOMContentLoaded', (e) => {
    document.querySelectorAll('[data-expand-id]').forEach(button => {
        new Expander(button);
    });
});